(function () {
  var STORAGE_KEY = 'cairoshoes:wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — fail silently */
    }
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { list: list, count: list.length } })
    );
    return list.indexOf(handle) > -1;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) {
      return h !== handle;
    });
    saveWishlist(list);
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { list: list, count: list.length } })
    );
  }

  function refreshButtonStates() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      var active = list.indexOf(handle) > -1;
      el.classList.toggle('is-active', active);
      if (el.tagName === 'BUTTON') {
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
        el.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      }
      var label = el.querySelector('.buy-buttons-block__wishlist-label');
      if (label) {
        label.textContent = active ? 'Remove from wishlist' : 'Add to wishlist';
      }
    });
  }

  function refreshBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshAll() {
    refreshButtonStates();
    refreshBadges();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggleWishlist(handle);
  });

  document.addEventListener('wishlist:updated', refreshAll);
  document.addEventListener('DOMContentLoaded', refreshAll);
  document.addEventListener('shopify:section:load', refreshAll);

  // Also catch storage changes from other tabs
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) refreshAll();
  });

  window.CairoWishlist = {
    get: getWishlist,
    has: isWishlisted,
    toggle: toggleWishlist,
    remove: removeFromWishlist,
    refresh: refreshAll
  };

  if (document.readyState !== 'loading') {
    refreshAll();
  }
})();
